import React from 'react'

const ArrowDown = () => (
  <svg
    fill='none'
    height='14'
    viewBox='0 0 12 14'
    width='12'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6 13.5V.5M11.5 8L6 13.5.5 8'
      stroke='var(--message__indicator__arrow__color)'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default ArrowDown
